import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=995f0716&scoped=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoard.vue?vue&type=style&index=0&id=995f0716&prod&scoped=true&lang=css"
import style1 from "./LeaderBoard.vue?vue&type=style&index=1&id=995f0716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995f0716",
  null
  
)

export default component.exports